import React, { useState } from "react";
import { IoMdAdd } from "react-icons/io";
import { TbPencilMinus } from "react-icons/tb";
import AddTenantSetting from "./AddTenantSetting";

const CardListView = ({ value, componentKey , fetchAllTenantData}) => {
  const { data, loaderComponent, cardTitle, titleDescription, id } = value;
 
  const [openAddTenantSettingModal, setOpenAddTenantSettingModal] = useState(false);
   const [editData, setEditData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const handleAdd = () => {
    setEditData(null);
    setIsEdit(false);
    setOpenAddTenantSettingModal(true);
  };

 const handleEdit = () => {
  if (!data || !data.length) return;
  setEditData(data); 
  setIsEdit(true);
  setOpenAddTenantSettingModal(true);
};

  return (
    <div className="flex flex-col justify-between overflow-hidden h-full">
      {openAddTenantSettingModal ? (
        <AddTenantSetting
          open={openAddTenantSettingModal}
          close={() => setOpenAddTenantSettingModal(false)}
          componentKey={componentKey}
           editData={data}
          isEdit={isEdit}   
          fetchAllTenantData={fetchAllTenantData}  
        />
      ) : null}
      <div>
        <div className="flex flex-col">
          <div className="flex justify-between gap-5">
            <div>
              <label className="text-gray-800 text-left text-lg font-semibold">
                {cardTitle}
              </label>
              <p className="text-gray-500 text-xs font-semibold">
                {titleDescription}
              </p>
            </div>
            <div className="flex gap-2 items-center text-lg">
               <button
              onClick={handleAdd}
              className="border rounded-md px-3 py-2 hover:text-white hover:bg-blue-500"
            >
              <IoMdAdd />
            </button>
               <button
              onClick={handleEdit}
              className="border rounded-md px-3 py-2 hover:text-white hover:bg-blue-500"
            >
              <TbPencilMinus />
            </button>
            </div>
          </div>
          {loaderComponent ? (
            <div className="flex justify-center items-center w-full h-[200px]">
              {loaderComponent}
            </div>
          ) : (
            <div className="mt-1 space-y-3 max-h-[300px] overflow-y-auto">
              {data.map((val, index) => (
                <div
                  key={`card_list_view_data_map_${index}`}
                  className="border-l-2 border-primary/20 pl-3 flex flex-col"
                >
                  <span className="text-gray-800 font-semibold text-base">
                    {val.title}
                  </span>
                  {val.description ? (
                    <span className="text-sm font-medium">
                      {val.description}
                    </span>
                  ) : null}
                  
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {/* <div className="flex justify-center items-center w-full">
        <button className="text-blue-600 font-medium">Add details</button>
      </div> */}
    </div>
  );
};

export default CardListView;
